/**
 * 转账记录 — GET /api/admin/ledger?actions=transfer_out,transfer_in
 */
import { LedgerPage } from './LedgerPage';

export function TransferLogPage() {
  return <LedgerPage variant="transfer" />;
}
